// Vendor libraries
import { BrowserModule } from '@angular/platform-browser';
import { StoreModule } from '@ngrx/store';
// Module imports
import { ConfigModule } from 'NewAngular/config/config.module';
import { ModalBaseModule } from 'NewAngular/features/components/modals/modal-base/modal-base.module';
import { NavigationModule } from 'NewAngular/features/components/navigation/navigation.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { ImageModule } from 'NewAngular/features/directives/image/image.module';
import { getLogger } from 'NewAngular/state/logger';
// Component imports
import { SideMenuComponent } from 'NewAngular/features/components/side-menu/side-menu.component';
import { SupportCategoryPageComponent } from './components/support-category-page/support-category-page.component';
import { TopBarNavComponent } from 'NewAngular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
export class AppModule {
}
AppModule.ɵfac = function AppModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AppModule)(); };
AppModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AppModule, bootstrap: [SupportCategoryPageComponent, TopBarNavComponent, SideMenuComponent] });
AppModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BrowserModule,
        ConfigModule,
        IconModule,
        ImageModule,
        NavigationModule,
        ModalBaseModule,
        StoreModule.forRoot({}, { metaReducers: getLogger() })] });
